function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusPlant = function SvgPlusPlant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193.12 186.88"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.59 184.88s9.95-99.83-19.89-129.77C61.16 34.49 21.67 34.17 7.42 34.8c-3.08.13-5.49 2.71-5.42 5.81.29 13.14 4.63 46.71 39.91 64.41C61.8 115 101.59 115 101.59 115",
    style: {
      stroke: "#007533",
      fill: "none",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.96 45.12C139.15-2.24 173.91.34 186.38 3.49c3.04.77 5.03 3.67 4.69 6.8-1.78 16.45-12.68 68.05-79.22 84.75",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4,
      stroke: "#00db33"
    }
  })));
};
export default SvgPlusPlant;